import axiosClient from "../../../shared/lib/axiosClient";
import { COURSE_API_BASE } from "../../../shared/utils/apiConfig";
import type {
    Cheatsheet,
    CheatsheetList,
    CheatsheetListResponse,
    CheatsheetResponse
} from "../types";

type Id = number | string;

// All cheatsheets of a course the user is enrolled in
export const getCheatsheets = async (
    userId: Id,
    courseId: string,
    signal?: AbortSignal
): Promise<CheatsheetList> => {
    const { data } = await axiosClient.get<CheatsheetListResponse>(
        `${COURSE_API_BASE}/${userId}/courses/${courseId}/cheatsheets/`,
        { signal }
    );

    if (!data.success) throw new Error("");

    return { title: data.title ?? "", cheatsheets: data.cheatsheets ?? [] };
};

// One cheatsheet. Returns null when it doesn't exist.
export const getCheatsheet = async (
    userId: Id,
    courseId: string,
    cheatsheetId: string,
    signal?: AbortSignal
): Promise<Cheatsheet | null> => {
    const { data } = await axiosClient.get<CheatsheetResponse>(
        `${COURSE_API_BASE}/${userId}/courses/${courseId}/cheatsheets/${cheatsheetId}`,
        { signal }
    );

    return data.success && data.cheatsheet ? data.cheatsheet : null;
};